import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "projects/assist/src/app/_shared/services/base.service";

import { HotToastService } from "@ngneat/hot-toast";
import {
  ProductGroup,
  ProductGroupWithProducts,
} from "projects/assist/src/app/product/models/product-group";
import { Observable } from "rxjs";
import { BasicDto } from "../../_shared/models/basicDto";

@Injectable({
  providedIn: "root",
})
export class ProductGroupService extends BaseService<ProductGroup, ProductGroupWithProducts> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    protected override toast: HotToastService
  ) {
    super(http, baseUrl, "ProductGroup", toast);
  }

  getAllGroups() {
    return this.getAll("/all");
  }

  getAllBasic(): Observable<BasicDto<number>[]> {
    return this.getAll("/basic");
  }
}
